export default __webpack_public_path__ + "static/media/peg.bbb388b1.gif";